import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const ideasPlugin = createPlugin({
  id: 'ideas',
  routes: {
    root: rootRouteRef,
  },
});

export const IdeasPage = ideasPlugin.provide(
  createRoutableExtension({
    name: 'IdeasPage',
    mountPoint: rootRouteRef,
    component: () =>
      import('./components/IdeasPage').then(m => m.IdeasPage),
  }),
);
